document.addEventListener('DOMContentLoaded', function() {
  // Function to update background image
  function updateBackgroundImage(swatchUrl) {
    const mediaGallery = document.querySelector('.product-blob');
    if (swatchUrl && mediaGallery) {
      // Apply the background image correctly with url wrapping
      mediaGallery.style.backgroundImage = `url('${swatchUrl}')`;
    }
  }

  // Select all color swatches and attach an event listener to each
  document.querySelectorAll('.color__swatch').forEach(swatch => {
    swatch.addEventListener('click', function() {
      const swatchUrl = this.getAttribute('data-swatch-url');
      updateBackgroundImage(swatchUrl);
    });
  });

  // Handle the first available variant on initial load
  const initialSwatch = document.querySelector('.product-form__input input[type=radio]:checked+label'); // Select the initially checked input
  if (initialSwatch) {
    const swatchLabel = initialSwatch.closest('.color__swatch');
    if (swatchLabel) {
      const initialSwatchUrl = swatchLabel.getAttribute('data-swatch-url');
      updateBackgroundImage(initialSwatchUrl);
    }
  }
});